import {
  Reuse9141,
  Reuse9089,
  Reuse790A,
  Reuse9035,
  Reuse790AV2,
} from "./forms";

export const ReuseResolver = (form_id, formVersionId) => {
  const obj = {
    9035: Reuse9035,
    9141: Reuse9141,
    9089: Reuse9089,
    "790A": Reuse790A,
  };
  if (form_id === "790A" && formVersionId === 2) {
    return Reuse790AV2;
  }
  return obj[form_id] || undefined;
};
